import { api } from './client';

export async function pushSubscribe(sub: { endpoint: string; keys: { p256dh: string; auth: string } }) {
  return api.post<{ ok: boolean }>('/push/subscribe', sub);
}
export async function pushUnsubscribe(endpoint: string) {
  return api.post<{ ok: boolean }>('/push/unsubscribe', { endpoint });
}
export async function pushTest() {
  return api.post<{ ok: boolean }>('/push/test');
}
